export default __webpack_public_path__ + "static/media/London_&_Partners_logo.e43b542b.png";